import React, { useEffect, useState } from 'react'
import { APIENDPOINT, getCWPEnvironmentForURL, sanitizeHTML } from '../../../../utils/common-utils'
import { FeatureFlag, FeatureFlagProps } from './FeatureFlag'

export type CardContentProps = {
  cardImage?: string
  heading?: string
  cardHeadingLevel?: 'h3' | 'h4'
  superHeadline?: string
  cardDescription?: string
  readTime?: string
  author?: string
  date?: string
  featureFlag?: FeatureFlagProps
  url?: string
  dataAnalytics?: string
  hideImage?: string
  rawDate?: string
}

export const CardContent = (props: CardContentProps) => {
  const {
    cardDescription,
    cardImage,
    heading,
    superHeadline,
    cardHeadingLevel,
    readTime,
    featureFlag,
    author,
    date,
    hideImage = 'false',
  } = props

  const [imagePath, setImagePath] = useState('')

  useEffect(() => {
    if (cardImage) {
      setImagePath(cardImage)
      return
    }

    const baseUrl = APIENDPOINT(getCWPEnvironmentForURL(window.location.toString())).baseGallery
    const defaultImagePath = `${baseUrl}/content/gallery/ampmicrosites/card-default-image.png`
    setImagePath(defaultImagePath)
  }, [cardImage])

  const getCardDetails = () => {
    if (!author && !readTime && !date) {
      return null
    }
    const details = [author, date, readTime].filter(item => !!item)
    return (
      <div className='card-bottom u-sizeFull u-paddingHoriz20'>
        <p className='u-textColorLight u-textSizeMsrm1'>
          {details.map((detail, index) => (
            <React.Fragment key={index}>
              <span>{detail}</span>
              {index < details?.length - 1 && <span className='u-marginHoriz4'>&bull;</span>}
            </React.Fragment>
          ))}
        </p>
      </div>
    )
  }

  return (
    <>
      {featureFlag && (
        <FeatureFlag backgroundColor={featureFlag.backgroundColor} label={featureFlag.label} />
      )}
      {hideImage === 'false' && (
        <div className='Card-header Card-headerBackgroundImage Card--redesign card-image'>
          {imagePath && <img src={imagePath} alt='' />}
        </div>
      )}
      <div className='Card-body card-content u-paddingHoriz20'>
        {superHeadline && (
          <h4
            className={`u-textColorLight u-textSizeMsrm1 u-textUppercase u-textBold card-super-headline ${
              hideImage === 'true' && 'u-marginBottom8'
            }`}
          >
            {superHeadline}
          </h4>
        )}
        {heading && (
          <div>
            {cardHeadingLevel === 'h4' ? (
              <h4 className='card-heading u-paddingVert8 u-textColorNeutralGrey'>
                <strong>{heading}</strong>
              </h4>
            ) : (
              <h3 className='card-heading u-paddingVert8 u-textColorNeutralGrey'>
                <strong>{heading}</strong>
              </h3>
            )}
          </div>
        )}
        <div
          className='card-description'
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(cardDescription ?? '') }}
        />
      </div>
      {getCardDetails()}
    </>
  )
}
